import {ICompaniesDTO, ICompanyQuery} from "./dto/ICompanies";
import {BaseModel} from "../../model/shared/BaseModel";
import {requests} from "../../utils/helpers/api.services";
import {COMPANY_URL} from "../../utils/helpers/api.routes";

export const CompanyService = {
    getAllCompanies: (params: ICompanyQuery): Promise<BaseModel<ICompaniesDTO[]>> => requests.get(`${COMPANY_URL}`, params),
    getCompanyById: (id: number) => requests.get(`${COMPANY_URL}/${id}`),
    deleteCompanyById: (id: number) => requests.delete(`${COMPANY_URL}/${id}`),
}